import { Injectable } from '@angular/core';
import { Product } from '../models/product';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ProductService {

  constructor( private http: HttpClient ) { }

  async getProducts() : Promise<Product[]> {
    return this.http.get<Product[]>('/api/product').toPromise();
  }

  async postProduct(product:Product) : Promise<Product> {
    return this.http.post<Product>('/api/product', product).toPromise();
  }

  async getProduct(id:Number) : Promise<Product> {
    return this.http.get<Product>('/api/product/' + id).toPromise();
  }
  
  async putProduct(product:Product) : Promise<Product> {
    return this.http.post<Product>('/api/product/' + product.id + '/edit', product).toPromise();
  }
  
  async deleteProduct(product:Product) : Promise<void> {
    return this.http.get<void>('/api/product/' + product.id + '/delete').toPromise();
  }
}
